import { hero, tickers, siteMeta } from "@/mocks/daily";

export default function Hero() {
  return (
    <section id="today" className="w-full bg-background-50">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6 pt-8 md:pt-12">
        <div className="grid gap-8 md:gap-10 lg:grid-cols-[1.05fr_1fr] lg:items-center">
          {/* 左：今日头条文案 */}
          <div className="animate-fade-up">
            <div className="flex items-center gap-3 text-xs text-foreground-500">
              <span className="inline-flex items-center gap-1.5 text-foreground-600">
                <i className="ri-calendar-2-line" aria-hidden="true"></i>
                2026年9月9日 · 星期三
              </span>
              <span className="h-1 w-1 rounded-full bg-background-300" aria-hidden="true"></span>
              <span className="text-foreground-500">全网热度持续追踪中</span>
            </div>

            <h1 className="mt-5 font-serif text-3xl md:text-5xl font-black leading-tight text-foreground-950 text-balance">
              {hero.title}
            </h1>
            <p className="mt-5 max-w-xl text-base md:text-lg leading-relaxed text-foreground-600">{hero.lead}</p>

            <div className="mt-5 flex flex-wrap gap-2">
              {hero.tags.map((t) => (
                <span
                  key={t}
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-100 px-3 py-1 text-xs text-foreground-600 border border-background-200"
                >
                  <i className="ri-hashtag text-primary-500" aria-hidden="true"></i>
                  {t.replace("#", "")}
                </span>
              ))}
            </div>

            <div className="mt-7 flex flex-wrap gap-3">
              <a
                href="#featured"
                className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
              >
                立即开读 · 精选
                <i className="ri-arrow-right-line text-sm" aria-hidden="true"></i>
              </a>
              <a
                href="#hot"
                className="inline-flex whitespace-nowrap items-center gap-2 rounded-md bg-background-100 px-5 py-2.5 text-sm font-medium text-foreground-800 border border-background-200 transition-colors hover:bg-background-200"
              >
                <i className="ri-fire-line text-primary-500" aria-hidden="true"></i>
                查看实时热榜
              </a>
            </div>
          </div>

          {/* 右：主视觉图 */}
          <div className="relative animate-fade-up lg:justify-self-end">
            <div className="relative overflow-hidden rounded-xl bg-background-200">
              <img
                src={hero.image}
                alt="今日全网热门话题编辑插画：聚集的人群与刷屏的手机屏幕"
                title="每日爆料 今日热搜头条"
                className="h-64 w-full object-cover object-top md:h-[380px]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/45 via-transparent to-transparent" />
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-primary-500 px-2.5 py-1 text-xs font-medium text-background-50">
                <span className="relative flex h-2 w-2">
                  <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-background-50 opacity-70"></span>
                  <span className="relative inline-flex h-2 w-2 rounded-full bg-background-50"></span>
                </span>
                LIVE
              </span>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <p className="font-serif text-lg text-background-50">{siteMeta.slogan}</p>
              </div>
            </div>
            <div className="absolute -bottom-3 left-4 rounded-md bg-accent-500 px-3 py-1.5 font-serif text-sm font-bold text-background-50 shadow-sm">
              今日头条 · TOP 1
            </div>
          </div>
        </div>
      </div>

      {/* 快讯滚动条 */}
      <div className="mt-10 w-full overflow-hidden border-y border-foreground-950/10 bg-background-100">
        <div className="flex items-center">
          <span className="relative z-10 flex shrink-0 items-center gap-1.5 bg-primary-500 px-3 md:px-4 py-2.5 text-xs font-bold tracking-widest text-background-50">
            <i className="ri-flashlight-line text-sm" aria-hidden="true"></i>
            快讯
          </span>
          <div className="relative flex-1 overflow-hidden">
            <div className="flex w-max animate-ticker items-center gap-10 px-6 py-2.5 whitespace-nowrap">
              {[...tickers, ...tickers].map((t, i) => (
                <span key={i} className="inline-flex items-center gap-2 text-sm text-foreground-700">
                  <i className="ri-record-circle-fill text-[8px] text-accent-600" aria-hidden="true"></i>
                  {t}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}